import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorksMaterials: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,
	},
	getRegulationsStagesPlanWorksMaterialPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_PREVIEW,
	},
	getRegulationsStagesPlanWorksMaterialPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_POPUP,
	},
	createRegulationsStagesPlanWorksMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].CREATE_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL,
	},
	getRegulationsStagesPlanWorksMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL,
	},
	patchRegulationsStagesPlanWorksMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].PATCH_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL,
	},
	putRegulationsStagesPlanWorksMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].PUT_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL,
	},
	deleteRegulationsStagesPlanWorksMaterial: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS].DELETE_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL,
	},
}